import React from 'react';
import moment from 'moment';

import {
	dayTimeUSFormat,
	timeUsFormat,
} from 'resolvers/date-format.resolver';

const HALF_OF_HOUR_IN_MILLISECONDS = 30 * 60 * 1000;

class Event extends React.Component {
	render() {
		const {
			event: {
				title,
				tooltip,
				start,
				end,
			},
		} = this.props;

		const getFormattedDate = (date, format = timeUsFormat) => moment(date).add(10, 'second').format(format);
		const formattedDateStart = getFormattedDate(start);
		const formattedDateEnd = getFormattedDate(end);
		const formattedDateAllDayStart = getFormattedDate(start, dayTimeUSFormat);
		const formattedDateAllDayEnd = getFormattedDate(end, dayTimeUSFormat);

		const smallTitle = (
			<div>{formattedDateStart} - {formattedDateEnd} - {title}</div>
		);

		const bigTitle = (
			<div>
				{formattedDateStart} - {formattedDateEnd}
				<br />
				{title}
			</div>
		);

		const allDayTitle = (
			<div title={title}>
				{formattedDateAllDayStart} - {formattedDateAllDayEnd} - {title}
			</div>
		);

		const isSmallRange = (new Date(end) - new Date(start)) < HALF_OF_HOUR_IN_MILLISECONDS;

		return (
			<div className="event">
				<div className="day-label" title={tooltip}>
					{isSmallRange ? smallTitle : bigTitle}
				</div>
				<div className="preview-label" title={tooltip}>
					{smallTitle}
				</div>
				<div className="all-day-label" title={tooltip}>
					{allDayTitle}
				</div>
			</div>
		);
	}
}

export default Event;
